import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconSplit = props => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path d="m0 0v6l2.3008-2.3008 4.6992 4.7012v7.5996h2v-8.4004l-5.3008-5.2988 2.3008-2.3008h-6zm10 0l2.301 2.3008-2.9006 2.8984 1.4006 1.4004 2.898-2.9004 2.301 2.3008v-6h-6z" />
  </SvgIcon>
);

export default IconSplit;



// WEBPACK FOOTER //
// ./src/components/icons/IconSplit.js